///这是删选器（日语-语法）的主面板

// import { React, useState, useRef, useEffect } from "react";
import { Space, Slider, Button, Segmented, Collapse } from 'antd-mobile'
import styles from './Filter.module.css'
import TagFilter from "./TagFilter_JPGramma.js";

const states = require('../../../utils/states.js')

const levelMarks = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
}
//删选选项 level_min / level_max / root[] / prep[] / form[]
export default (props) => {
  let _curFilter = states.filterWrap.cur_gramma_filter

  //#region arrange
  const arrangeValue = (value) => {
    if (value === '默认') {
      _curFilter.arrange = 'default'
    } else {
      _curFilter.arrange = 'random'
    }
  }
  //#endregion

  //#region level slider
  const toastValue = (value) => {
    if (typeof value === 'number') {
      _curFilter.level_min = _curFilter.level_max = value
    } else {
      _curFilter.level_min = value[0]
      _curFilter.level_max = value[1]
    }
  }
  //#endregion


  async function onSubmit(display) {
    console.log('提交filter', display)
    _curFilter.display = display

    await states.downloadGrammaByFilter((bSuccess) => {
      if (bSuccess) {
        props.filterFunc.CloseFilterPanel?.()
        props.filterFunc.RefreshList?.()
        states.filterWrap.saveFilter()
      }
    })

  }

  return (<div className={styles.app}>
    <div className={styles.top}>
      <Space direction="vertical" style={{ width: '100%' }}>
        <div className={styles.arrange}>
          <Space style={{ '--gap': '30px' }}>
            <div style={{ 'lineHeight': '30px' }}>排序方式</div>
            <Segmented defaultValue={_curFilter.arrange === 'default' ? '默认' : '随机'}
              block options={['默认', '随机']}
              onChange={arrangeValue} />
          </Space>
        </div>
        <div className={styles.slider}>
          <div style={{ 'lineHeight': '30px' }}>根据Level删选</div>
          <Slider className={styles.slider}
            defaultValue={[_curFilter.level_min, _curFilter.level_max]}
            marks={levelMarks} step={1} min={1} max={5} ticks range
            onAfterChange={toastValue}
          />
        </div>
        <div className={styles.tags}>
          <Collapse style={{ padding: 0 }} defaultActiveKey={['1']}>
            <Collapse.Panel className={styles.cpanel} key='1' title='词根' >
              <TagFilter listShell={states.rootTagsWrap} />
            </Collapse.Panel>
            <Collapse.Panel className={styles.cpanel} key='2' title='介词'>
              <TagFilter listShell={states.prepTagsWrap} />
            </Collapse.Panel>
            <Collapse.Panel className={styles.cpanel} key='3' title='语态'>
              <TagFilter listShell={states.formTagsWrap} />
            </Collapse.Panel>
          </Collapse>

        </div>


      </Space>
    </div>
    <div className={styles.display}>
      <Space justify="center" block>
        <Button onClick={() => onSubmit('continue')} size="small" color='primary'>接续</Button>
        <Button onClick={() => onSubmit('gramma')} size="small" color='primary'>语法</Button>
        <Button onClick={() => onSubmit('main')} size="small" color='warning'>主体</Button>
        <Button onClick={() => onSubmit('definition')} size="small" color='warning'>解释</Button>
        <Button onClick={() => onSubmit('all')} size="small" color='success'>全显</Button>
        {/* <Button size="small" color='default'>测试</Button> */}
      </Space>
    </div>
  </div>)

}